export default __webpack_public_path__ + "static/about-us-support-4-da45b118a10794d3ce33e287c982fa53.png";